/**
 * Entry application component used to compose providers and render Routes.
 * */

import React from "react";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { PersistGate } from "redux-persist/integration/react";
import { LastLocationProvider } from "react-router-last-location";
import { Routes } from "./app/router/Routes";
import { I18nProvider, LayoutSplashScreen } from "./_metronic";
import bsCustomFileInput from "bs-custom-file-input";

import { ThemeProvider } from "styled-components";
import { mutantColors } from "./app/assets/styles/themes/default";
import { ClearCacheProvider, useClearCache } from "react-clear-cache";

bsCustomFileInput.init();

const history = createBrowserHistory();

export default function App({ store, persistor, basename }) {
	const { isLatestVersion, emptyCacheStorage } = useClearCache();
	if (!isLatestVersion && emptyCacheStorage) {
		emptyCacheStorage();
	}

	return (
		/* Provide Redux store */
		<ClearCacheProvider auto={true}>
			<ThemeProvider theme={mutantColors}>
				<Provider store={store} loading={<LayoutSplashScreen />}>
					<PersistGate persistor={persistor}>
						<Router basename={basename} history={history}>
							<LastLocationProvider>
								<I18nProvider>{<Routes />}</I18nProvider>
							</LastLocationProvider>
						</Router>
					</PersistGate>
				</Provider>
			</ThemeProvider>
		</ClearCacheProvider>
	);
}
